import { useTranslation } from "react-i18next";

export default function LanguageSwitcher({ className = "" }) {
  const { i18n } = useTranslation();

  const change = (lng) => {
    if (lng === i18n.language) return;
    i18n.changeLanguage(lng);
    localStorage.setItem("luv-lang", lng);
  };

  return (
    <div
      data-testid="language-switcher"
      className={`flex items-center rounded-full border border-[#F5CB5C]/25 bg-[#F5CB5C]/5 p-0.5 text-[11px] font-bold tracking-wide ${className}`}
    >
      <button
        data-testid="lang-es-button"
        onClick={() => change("es")}
        className={`px-2.5 py-1 rounded-full transition-all duration-300 ${
          i18n.language === "es" ? "bg-gradient-to-br from-[#FAE19C] via-[#F5CB5C] to-[#C69222] text-[#05070A]" : "text-gray-400 hover:text-[#F5CB5C]"
        }`}
      >
        ES
      </button>
      <button
        data-testid="lang-en-button"
        onClick={() => change("en")}
        className={`px-2.5 py-1 rounded-full transition-all duration-300 ${
          i18n.language === "en" ? "bg-gradient-to-br from-[#FAE19C] via-[#F5CB5C] to-[#C69222] text-[#05070A]" : "text-gray-400 hover:text-[#F5CB5C]"
        }`}
      >
        EN
      </button>
    </div>
  );
}
